export const ObjectFitClasses = {
  CONTAIN: ["wf-object-contain"],
  COVER: ["wf-object-cover"],
  FILL: ["wf-object-fill"],
  NONE: ["wf-object-none"],
  SCALE_DOWN: ["wf-object-scale-down"]
}
